<script setup lang="ts">
import ActionButton from "~components/widgets/ActionButton.vue"

defineProps<{ dateRangeActive: (label: string) => boolean }>()

const emit = defineEmits(["search", "set-date-range"])

const onSearch = () => emit("search")
const onSetDateRange = (days: number) => emit("set-date-range", days)
</script>

<template>
  <div>
    <b-button-group size="sm">
      <b-button
        :variant="dateRangeActive('7d') ? 'primary' : 'outline-secondary'"
        @click="onSetDateRange(7)"
      >7d</b-button>
      <b-button
        :variant="dateRangeActive('14d') ? 'primary' : 'outline-secondary'"
        @click="onSetDateRange(14)"
      >14d</b-button>
      <b-button
        :variant="dateRangeActive('30d') ? 'primary' : 'outline-secondary'"
        @click="onSetDateRange(30)"
      >30d</b-button>
      <b-button
        :variant="dateRangeActive('all') ? 'primary' : 'outline-secondary'"
        @click="onSetDateRange(0)"
      >All</b-button>
    </b-button-group>

    <div class="d-flex justify-content-center mb-2">
      <div class="tip">Tip: click on any row to expand it</div>
    </div>

    <div class="d-flex justify-content-center mb-3">
      <action-button action="search" @click.prevent="onSearch()">Search</action-button>
    </div>
  </div>
</template>
